import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserRoleState {
  firstName: string;
  lastName: string;
  emailId: string;
  roleId: number;
  userId: number;
  roleName: string;
  currentDepartmentsDetails: string[];
  departmentNames: string[];
}

const initialState: UserRoleState = {
  firstName: '',
  lastName: '',
  emailId: '',
  roleId: 0,
  userId: 0,
  roleName: '',
  currentDepartmentsDetails: [],
  departmentNames: [],
};

const userRoleSlice = createSlice({
  name: 'userRole',
  initialState,
  reducers: {
    setUserRoleDetails: (state, action: PayloadAction<Partial<UserRoleState>>) => {
      return { ...state, ...action.payload };
    },
    resetUserRole: () => initialState,
  },
});

export const { setUserRoleDetails, resetUserRole } = userRoleSlice.actions;
export default userRoleSlice.reducer;
